import InnerBox from '@repo/ui/inner-box'
import { useFormContext } from 'react-hook-form'

import { CseInput } from '../../../lib/types/models/cse/cse'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'

const CseCommentFormSection = () => {
  const form = useFormContext<CseInput>()
  return (
    <InnerBox title="Commentaires" className="rounded-xl">
      <FormField
        control={form.control}
        name="comments"
        render={({ field }) => (
          <FormItem className="flex-1">
            <FormControl>
              <ControlledInput {...field} label="Commentaire" type="textarea" rows={5} />
            </FormControl>
          </FormItem>
        )}
      />
    </InnerBox>
  )
}

export default CseCommentFormSection
